import { map } from 'lodash/fp';
import { generateTranslationByVenueType, translate } from '../../../../../utils';
import { Category, Product as ProductType, Tax, VenueType } from '../../../../../generated/graphql';
import { HeadCell, Row, RowData } from './types';

export const getProductTableHeadCells = (venueType: VenueType): Array<HeadCell<Row>> => [
    { id: 'name', align: 'left', label: translate('Name') },
    { id: 'category', align: 'center', label: translate('Category') },
    {
        id: 'foodCost', align: 'right', label: generateTranslationByVenueType({
            translations: {
                Ecommerce: translate('COGS'),
                Restaurant: translate('Food cost')
            },
            venueType
        }),
    },
    { id: 'markup', align: 'right', label: translate('Markup') },
    { id: 'priceSellWithoutVat', align: 'right', label: translate('Price without VAT') },
    { id: 'priceSell', align: 'right', label: translate('Price') },
];


interface Product extends Pick<ProductType, 'id' | 'name' | 'priceSell' | 'foodCost' | 'markup'>{
    category: Pick<Category, 'name' | 'categoryId'>;
    tax: Pick<Tax, 'rate'>;
}

export const mapProductsToRows = map<Product, RowData>(({
    id,
    name,
    priceSell,
    category,
    markup,
    foodCost,
    tax,
}) => ({
    id,
    name,
    priceSell,
    category,
    markup,
    foodCost,
    taxRate: tax.rate,
}));
